import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

const MermaidDiagram = ({ chart, id }) => {
  const chartRef = useRef();

  useEffect(() => {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'default',
      securityLevel: 'loose'
    });

    const renderChart = async () => {
      if (chartRef.current) {
        try {
          chartRef.current.innerHTML = '';
          const { svg } = await mermaid.render(`mermaid-${id}`, chart);
          chartRef.current.innerHTML = svg;
        } catch (error) {
          console.error('Mermaid rendering error:', error);
          chartRef.current.innerHTML = '<p>Error rendering diagram</p>';
        }
      }
    };

    renderChart();
  }, [chart, id]);

  return (
    <div 
      ref={chartRef} 
      style={{ 
        textAlign: 'center',
        padding: '1rem',
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: '#f8f9fa'
      }}
    />
  );
};

export default MermaidDiagram;
